// import { msalInstance } from "../msalConfig";
import apiServices from "../services/service";
import { clearCache } from "./authService";
import msalInstance from "./authServiceInstance";
import { tokenManager } from "./tokenManager";

export const logoutHandler = async () => {
    debugger;
    const loginType = tokenManager.getLoginType();
        const revokeToken = async () => {
        const revokeData = {
            refreshToken: tokenManager.getRefreshToken(),
        };
        await apiServices.revokeToken(revokeData);
    };
    try {
        if (loginType === "azure") {
            await msalInstance.logoutRedirect({
                postLogoutRedirectUri: "/login",
            });
        }
        if (loginType === "db") {
            await revokeToken();
            localStorage.clear();
            sessionStorage.clear();
            document.cookie.split(";").forEach((cookie) => {
                const name = cookie.split("=")[0].trim();
                document.cookie =
                    name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            });
            clearCache("error");
            window.location.href = "/login";
        }
        clearCache("Logout successful");
    } catch (error) {
        console.error(error);
        console.error("Logout failed:", error);
    }
};
